import { ServiceLogo } from '@on3/ui-lib/components/ServiceLogo/ServiceLogo';
import { useSubscribe } from '@on3/ui-lib/components/Subscription/Provider';
import { type BarrierTemplateProps } from '@on3/ui-lib/components/Subscription/Templates/Barrier';
import { TheAthletic } from '@on3/ui-lib/components/Svg/TheAthletic';
import { useAuth } from '@on3/ui-lib/contexts/AuthProvider';
import { useSite } from '@on3/ui-lib/contexts/SiteProvider';
import { createDescription } from '@public/utils/meta';
import clsx from 'clsx';

import styles from './TheAthleticBarrier.module.scss';

export const TheAthleticBarrier = ({
  handleJoin,
  handleLogin,
  template,
  preview = false,
}: BarrierTemplateProps) => {
  const { currentSite } = useSite();
  const { subscribeText } = useSubscribe();
  const { user } = useAuth();

  const title =
    template.data.title ||
    createDescription(
      `{0} {1} scoop, experts, and community-all in one.`,
      currentSite.isTeam ? currentSite.organization?.name : 'Inside',
      currentSite.isTeam ? currentSite.organization?.mascot : '',
    );
  const lineOne = template.data.line1;
  const lineTwo = template.data.line2;
  const buttonText =
    template.planData1?.buttonText || subscribeText || 'Join Now';
  const planKey = template.planKey1;

  return (
    <div
      className={clsx(styles.block, {
        [styles.preview]: preview,
      })}
      data-template-type="barrier"
    >
      <div className={styles.container}>
        <h2>{title}</h2>

        {(lineOne || lineTwo) && (
          <div className={styles.lines}>
            {!!lineOne && <div className={styles.lineOne}>{lineOne}</div>}
            {!!lineTwo && <div className={styles.lineTwo}>{lineTwo}</div>}
          </div>
        )}

        <div className={styles.promo}>
          <figure className={styles.logos}>
            <ServiceLogo className={styles.on3} type="on3" />
            <div className={styles.divider} />
            <TheAthletic />
          </figure>
          <div className={styles.subheading}>Now included with Annual</div>
        </div>

        <button
          className={styles.joinBtn}
          onClick={() => handleJoin(planKey)}
          type="button"
        >
          {buttonText}
        </button>
      </div>
      {!user?.uid && (
        <div className={styles.login}>
          <span>Already a subscriber?</span>
          <button onClick={handleLogin} type="button">
            Login
          </button>
        </div>
      )}
    </div>
  );
};
